import React, {useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Badge from '@material-ui/core/Badge';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import {API_URL} from '../index';
import Login from './Login';
import Main from './Main';
import Modal from '@material-ui/core/Modal';
import { Box, Table } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { TextareaAutosize } from '@material-ui/core';
import ReCAPTCHA from "react-google-recaptcha";
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  paper_style: {
    width: '70%',
    overflowX: 'auto',
  },
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 2,
  },
    container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  }
}));

export default function TopBar(props) {
  const classes = useStyles();

  const [startDate, setStartDate] = useState('2024-01-01');
  const [endDate, setEndDate] = useState('2024-01-01');
  const [report_data, setReportData] = useState(null);

  const [message, setMessage] = useState();
  const [isLogin, setIsLogin] = useState();
  const [redirect, setRedirect] = useState();
  const [username, setUsername] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isGuest, setGuest] = useState(false);
  const [spec, setSpec] = useState();

  const [open_doc_search, setOpenDocSearch] = React.useState(false);
  const openDocSearch = () => setOpenDocSearch(true);
  const closeDocSearch = () => setOpenDocSearch(false)
  const [doc_search_data, setDocSearchData] = useState(null);
  const [page, setPage] = useState(1);
  const [next_page, setNextPage] = useState(null);
  const [previous_page, setPreviousPage] = useState(null);
  const [pages_count, setPagesCount] = useState(0);

  const [open_report, setOpenReport] = React.useState(false);
  const openReport = () => setOpenReport(true);
  const closeReport = () => {setOpenReport(false); setStartDate('2024-01-01'); setEndDate('2024-01-01'); setReportData(null)}

  const setGuesNoLogin = () => {
       setIsLogin(false);setGuest(true)
  };

  useEffect(() => {
    if (localStorage.getItem('token') === 'undefined' ||
        localStorage.getItem('token') === null ||
        localStorage.getItem('token') === undefined)
      setGuesNoLogin()
    else
      setIsLogin(true)

    const user_url = API_URL + 'rest-auth/user/'
    const token = localStorage.getItem('token')

    fetch(user_url, {
            method: 'GET',
            headers:{ 'Content-Type': 'application/json', 'Authorization': 'Token ' + (token) }
          })
      .then(response => response.json())
      .then(data => setUsername(data.username))
    updateLoginData();

  }, []);

  const Logout = () => {
      const login_url = API_URL + 'rest-auth/logout/'
      fetch(login_url, {
          method: 'POST',
          headers:{ 'Content-Type': 'application/json' }
          })
          .then(response => response.json())
          .then(data => setMessage(data))
          .then(e => (localStorage.removeItem('token'), setRedirect(true)), setIsLogin(false))
  };

  const updateLoginData = () => {
    localStorage.getItem('token') === 'undefined' ||
    localStorage.getItem('token') === null ||
    localStorage.getItem('token') === undefined ?
    setIsLogin(false)
    :
    setIsLogin(true)
    
    const user_url = API_URL + 'rest-auth/user/'
    const token = localStorage.getItem('token')

    fetch(user_url, {
            method: 'GET',
            headers:{ 'Content-Type': 'application/json', 'Authorization': 'Token ' + (token) }
          })
      .then(response => response.json())
      .then(data => setUsername(data.username))
  };


  const UserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const UserMenuClose = () => {
    setAnchorEl(null);
  };

  const LoginAsGuest = () => {
    setGuest(true);
  }

  const getReport = () => {
  	const token = localStorage.getItem('token') != null ? 'Token ' + localStorage.getItem('token') : ''
    const report_url = API_URL + 'report?start=' + startDate + '&end=' + endDate
      fetch(report_url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
      })
      .then(response => response.json())
      .then(data => setReportData(data))
  };

  const getDocSearchData = (page) => {
  	const token = localStorage.getItem('token') != null ? 'Token ' + localStorage.getItem('token') : ''
      fetch(API_URL + 'owner_less_docs_list/' + '?page=' + page, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
      })
      .then(response => response.json())
      .then(data => {setDocSearchData(data);
                     setPage(page);
                     setNextPage(data.next != undefined & data.next != null ? data.next.split('page=').at(-1) : null);
                     setPreviousPage(data.previous != undefined & data.previous != null ? data.previous.split('page=').at(-1) : null);
                     setPagesCount(data.count);
                     if (typeof data.previous == 'string') {
                        if (!data.previous.includes('page=')) {
                            setPreviousPage(1)
                        }
                     };
                     })
  };

  const onNextPage = (e) => {
    if (next_page != null) {
       getDocSearchData(next_page)
    }
  }

  const onPreviousPage = (e) => {
    if (previous_page != null) {
       getDocSearchData(previous_page)
    }
  }

  const onChangeStart = (e) => {
    setStartDate(e.target.value)
  }

  const onChangeEnd = (e) => {
    setEndDate(e.target.value)
  }

  const style_report = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '75%',
    height: '75%',
    bgcolor: 'background.paper',
    border: 0,
    boxShadow: 24,
    p: 10,
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ background: '#1065b5' }}>
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={e => console.log(isLogin, isGuest)}>
            <MenuIcon />
          </IconButton>
          <Typography component="p" className={classes.title}>
          Местонахождение документов по личному составу
            </Typography>
          <Typography component="p" className={classes.title}>
          {isLogin ? username : isGuest ? 'Гость' : ''}
          </Typography>
          {isLogin ?
            <div>
            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Menu"
                        aria-controls="simple-menu" aria-haspopup="true" onClick={UserMenuOpen}>
                <AccountCircle />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={UserMenuClose}
            >
            <MenuItem onClick={UserMenuClose}>{username}</MenuItem>
            {username == 'admin' ? <MenuItem onClick={e => (openReport(), UserMenuClose())}>Отчёт</MenuItem> : ''}
            <Modal
              open={open_report}
              onClose={closeReport}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style_report}>
                  <form className={classes.container} noValidate>
                  <TextField
                    id="date_start"
                    label="Начало"
                    type="date"
                    defaultValue="2024-01-01"
                    onChange={onChangeStart}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    id="date_end"
                    label="Окончание"
                    type="date"
                    defaultValue="2024-01-01"
                    onChange={onChangeEnd}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Button onClick={getReport}>Отчёт</Button>
                </form>
                <p></p>
              <Box component="section" style={{overflowY: "scroll", position: 'absolute', height: '75%', width: '90%'}}>
              <Table className={classes.table} size='small'>
                <TableHead>
                  <TableRow style={{backgroundColor: '#4c5866'}}>
                  <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Вновь внесенные</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Отредактированные</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Удаленные</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}></TableCell>
                  </TableRow>
                  <TableRow style={{backgroundColor: '#4c5866'}}>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Архив</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Организации</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Документы</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Организации</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Документы</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Организации</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Документы</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Открытые</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Закрытые</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Фонд</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Действующие</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff'}}>Всего</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{overflowY: "scroll"}}>
                {report_data != null ? report_data.map(archive => (
                    <TableRow key={archive.id} hover style={{backgroundColor: ''}}>
                      <TableCell align="left" component="th" scope="row">{archive.title}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.organisations_edit.created}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.documents_edit.created}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.organisations_edit.edited}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.documents_edit.edited}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.organisations_edit.deleted}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.documents_edit.deleted}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.opened_organisations}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.closed_organisations}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.fund_organisations}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.active_organisations}</TableCell>
                      <TableCell align="left" component="th" scope="row">{archive.organisations}</TableCell>
                    </TableRow>
                )) : ''}
                </TableBody>
              </Table>
              </Box>
              </Box>
            </Modal>

            {username == 'admin' ? <MenuItem onClick={e => (openDocSearch(),
                                                            getDocSearchData(1),
                                                            UserMenuClose())}>Розыск</MenuItem> : ''}
            <Modal
              open={open_doc_search}
              onClose={closeDocSearch}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style_report} component="section" style={{overflowY: "scroll", position: 'absolute', height: '75%', width: '90%'}}>
              <Table className={classes.table} size='small'>
                <TableHead>
                  <TableRow style={{backgroundColor: '#4c5866'}} style={{backgroundColor: '#4c5866'}}>
                    <TableCell align="left" style={{color: '#f0f8ff', width: "10%"}}>Дата</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff', width: "20%"}}>Email</TableCell>
                    <TableCell align="left" style={{color: '#f0f8ff', width: "70%"}}>Текст</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {doc_search_data != null | doc_search_data != undefined ? doc_search_data.results.map(doc => (
                    <TableRow key={doc.id} hover style={{backgroundColor: ''}}>
                      <TableCell align="left">{doc.date.slice(0, 10)}</TableCell>
                      <TableCell align="left">{doc.email}</TableCell>
                      <TableCell align="left"><TextareaAutosize value={doc.text} minRows={1} style={{ width: "100%" }}/></TableCell>
                    </TableRow>
                )) : ''}
                </TableBody>
              </Table>
              <p>Всего записей: {pages_count}, страниц: {
                pages_count > 0 ?
                    Math.ceil(pages_count / 10)
                 : 0
              }</p>
              <p>Страница: {page}</p>
              <Button variant="contained" onClick={onPreviousPage} disabled={previous_page != null || previous_page != undefined ? false : true}>предыдущая</Button>
              <Button variant="contained" onClick={onNextPage} disabled={next_page != null || next_page != undefined ? false : true}>следующая</Button>
              </Box>
            </Modal>

            <MenuItem onClick={e => (Logout(), UserMenuClose())}>Выход</MenuItem>
            </Menu>
            </div>
            :
            <div>
            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Menu"
                        aria-controls="simple-menu" aria-haspopup="true" onClick={UserMenuOpen}>
                <AccountCircleOutlined />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={UserMenuClose}
            >
            <MenuItem onClick={UserMenuClose}>Гость</MenuItem>
            <MenuItem onClick={e => (setIsLogin(false), setGuest(false), UserMenuClose())}>Вход</MenuItem>
            </Menu>
            </div>
          }
        </Toolbar>
      </AppBar>
      { isLogin || isGuest ?
      <Main update_spec_count={updateLoginData} spec={spec}/> :
      <Login updateLoginData={updateLoginData} message={message} LoginAsGuest={LoginAsGuest}/>
      }
    </div>
  );
}